/**
 *  @class
 *  @function StickyScroller
 */
if (!customElements.get('sticky-scroller')) {
  class StickyScroller extends HTMLElement {

    constructor() {
      super();
      this.headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
      this.parent = this.parentElement;

    }

    connectedCallback() {
      this.newScrollPosition = 0;
      this.oldScrollPositon = 0;
      this.ticking = false;
      this.element = this.querySelector('.sticky-scroller--element');
      this.element.style.overflowY = 'hidden';
      this.onWindowScrollBound = this.onWindowScroll.bind(this);
      this.observer = new ResizeObserver(this.onWindowScrollBound);

      this.observer.observe(this.parent);
      window.addEventListener('scroll', this.onWindowScrollBound, {
        passive: true
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onWindowScrollBound);
      if (this.observer) {
        this.observer.disconnect();
      }
    }
    onWindowScroll() {
      this.newScrollPosition = window.scrollY;

      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.translate();
          this.ticking = false;
          this.oldScrollPositon = this.newScrollPosition;
        });

        this.ticking = true;
      }
    }

    translate() {
      const parentRect = this.parentElement.getBoundingClientRect();
      const distance = this.newScrollPosition - this.oldScrollPositon;
      // Do not scroll up before sticky period
      if (parentRect.top > this.headerHeight && distance > 0) {
        return;
      }
      // Do not scroll down after sticky period
      if (parentRect.bottom < window.innerHeight && distance < 0) {
        return;
      }
      this.element.scrollTop += distance;
    }
  }
  customElements.define('sticky-scroller', StickyScroller);
}

// Force In Stock checkbox to be checked ON every page load
(function () {
  function forceInStockChecked() {
    var checkbox = document.querySelector('[data-availability-default="true"]');
    if (!checkbox) return;
    
    // Get URL parameters
    var urlParams = new URLSearchParams(window.location.search);
    var isActiveInURL = urlParams.get('filter.v.availability') === '1';
    
    // If checkbox is not checked OR URL doesn't have the parameter, check it
    if (!checkbox.checked || !isActiveInURL) {
      checkbox.checked = true;
      
      // Trigger change event to apply the filter
      var event = new Event('change', { bubbles: true });
      checkbox.dispatchEvent(event);
    }
  }

  // Run on every page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', forceInStockChecked);
  } else {
    forceInStockChecked();
  }
  
  // Also run when page is restored from bfcache (back/forward buttons)
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      forceInStockChecked();
    }
  });
})();